/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  LateNoticeSettingsIn,
  LateNoticeSettingsOut,
  ListNoticesParams,
  ListRenewalsParams,
  NoticeCreateIn,
  NoticeDeliveryIn,
  NoticeEditIn,
  NoticeOut,
  PaginatedNoticeOut,
  PaginatedRenewalOut,
  RenewalIn,
  RenewalOut,
  RentChangeIn,
  RentChangeOut,
  RentChangesOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listNoticesResponse200 = {
  data: PaginatedNoticeOut
  status: 200
}

export type listNoticesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listNoticesResponseSuccess = (listNoticesResponse200) & {
  headers: Headers;
};
export type listNoticesResponseError = (listNoticesResponse422) & {
  headers: Headers;
};

export type listNoticesResponse = (listNoticesResponseSuccess | listNoticesResponseError)

export const getListNoticesUrl = (params?: ListNoticesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notices?${stringifiedParams}` : `/api/notices`
}

/**
 * @summary List Notices
 */
export const listNotices = async (params?: ListNoticesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listNoticesResponse> => {

  return apiFetch<listNoticesResponse>(getListNoticesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNoticesQueryKey = (params?: ListNoticesParams,) => {
    return [
    `/api/notices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNoticesQueryOptions = <TData = Awaited<ReturnType<typeof listNotices>>, TError = HTTPValidationError>(params?: ListNoticesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNoticesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotices>>> = ({ signal }) => listNotices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNoticesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotices>>>
export type ListNoticesQueryError = HTTPValidationError


export function useListNotices<TData = Awaited<ReturnType<typeof listNotices>>, TError = HTTPValidationError>(
 params: undefined |  ListNoticesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotices>>,
          TError,
          Awaited<ReturnType<typeof listNotices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotices<TData = Awaited<ReturnType<typeof listNotices>>, TError = HTTPValidationError>(
 params?: ListNoticesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotices>>,
          TError,
          Awaited<ReturnType<typeof listNotices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotices<TData = Awaited<ReturnType<typeof listNotices>>, TError = HTTPValidationError>(
 params?: ListNoticesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notices
 */

export function useListNotices<TData = Awaited<ReturnType<typeof listNotices>>, TError = HTTPValidationError>(
 params?: ListNoticesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNoticesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createNoticeResponse201 = {
  data: NoticeOut
  status: 201
}

export type createNoticeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createNoticeResponseSuccess = (createNoticeResponse201) & {
  headers: Headers;
};
export type createNoticeResponseError = (createNoticeResponse422) & {
  headers: Headers;
};

export type createNoticeResponse = (createNoticeResponseSuccess | createNoticeResponseError)

export const getCreateNoticeUrl = () => {




  return `/api/notices`
}

/**
 * @summary Create Notice
 */
export const createNotice = async (noticeCreateIn: NoticeCreateIn, options?: Parameters<typeof apiFetch>[1]): Promise<createNoticeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createNoticeResponse>(getCreateNoticeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noticeCreateIn)
  }
);}





export const getCreateNoticeMutationKey = () => ['createNotice'] as const;

export const getCreateNoticeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotice>>, TError,CreateNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotice>>, TError,CreateNoticeMutationVariables, TContext> => {

const mutationKey = getCreateNoticeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotice>>, CreateNoticeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createNotice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNoticeMutationResult = NonNullable<Awaited<ReturnType<typeof createNotice>>>
    export type CreateNoticeMutationBody = NoticeCreateIn
    export type CreateNoticeMutationError = HTTPValidationError
    export type CreateNoticeMutationVariables = {data: NoticeCreateIn}

    /**
 * @summary Create Notice
 */
export const useCreateNotice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotice>>, TError,CreateNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNotice>>,
        TError,
        CreateNoticeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateNoticeMutationOptions(options), queryClient);
    }
    export type editNoticeResponse200 = {
  data: NoticeOut
  status: 200
}

export type editNoticeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type editNoticeResponseSuccess = (editNoticeResponse200) & {
  headers: Headers;
};
export type editNoticeResponseError = (editNoticeResponse422) & {
  headers: Headers;
};

export type editNoticeResponse = (editNoticeResponseSuccess | editNoticeResponseError)

export const getEditNoticeUrl = (noticeId: number,) => {




  return `/api/notices/${noticeId}`
}

/**
 * @summary Edit Notice
 */
export const editNotice = async (noticeId: number,
    noticeEditIn: NoticeEditIn, options?: Parameters<typeof apiFetch>[1]): Promise<editNoticeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<editNoticeResponse>(getEditNoticeUrl(noticeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noticeEditIn)
  }
);}





export const getEditNoticeMutationKey = () => ['editNotice'] as const;

export const getEditNoticeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editNotice>>, TError,EditNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editNotice>>, TError,EditNoticeMutationVariables, TContext> => {

const mutationKey = getEditNoticeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editNotice>>, EditNoticeMutationVariables> = (props) => {
          const {noticeId,data} = props ?? {};

          return  editNotice(noticeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditNoticeMutationResult = NonNullable<Awaited<ReturnType<typeof editNotice>>>
    export type EditNoticeMutationBody = NoticeEditIn
    export type EditNoticeMutationError = HTTPValidationError
    export type EditNoticeMutationVariables = {noticeId: number;data: NoticeEditIn}

    /**
 * @summary Edit Notice
 */
export const useEditNotice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editNotice>>, TError,EditNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editNotice>>,
        TError,
        EditNoticeMutationVariables,
        TContext
      > => {
      return useMutation(getEditNoticeMutationOptions(options), queryClient);
    }
    export type deleteNoticeResponse204 = {
  data: void
  status: 204
}

export type deleteNoticeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteNoticeResponseSuccess = (deleteNoticeResponse204) & {
  headers: Headers;
};
export type deleteNoticeResponseError = (deleteNoticeResponse422) & {
  headers: Headers;
};

export type deleteNoticeResponse = (deleteNoticeResponseSuccess | deleteNoticeResponseError)

export const getDeleteNoticeUrl = (noticeId: number,) => {




  return `/api/notices/${noticeId}`
}

/**
 * @summary Delete Notice
 */
export const deleteNotice = async (noticeId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteNoticeResponse> => {

  return apiFetch<deleteNoticeResponse>(getDeleteNoticeUrl(noticeId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteNoticeMutationKey = () => ['deleteNotice'] as const;

export const getDeleteNoticeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotice>>, TError,DeleteNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotice>>, TError,DeleteNoticeMutationVariables, TContext> => {

const mutationKey = getDeleteNoticeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotice>>, DeleteNoticeMutationVariables> = (props) => {
          const {noticeId} = props ?? {};

          return  deleteNotice(noticeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNoticeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotice>>>

    export type DeleteNoticeMutationError = HTTPValidationError
    export type DeleteNoticeMutationVariables = {noticeId: number}

    /**
 * @summary Delete Notice
 */
export const useDeleteNotice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotice>>, TError,DeleteNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotice>>,
        TError,
        DeleteNoticeMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNoticeMutationOptions(options), queryClient);
    }
    export type sendNoticeResponse200 = {
  data: NoticeOut
  status: 200
}

export type sendNoticeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type sendNoticeResponseSuccess = (sendNoticeResponse200) & {
  headers: Headers;
};
export type sendNoticeResponseError = (sendNoticeResponse422) & {
  headers: Headers;
};

export type sendNoticeResponse = (sendNoticeResponseSuccess | sendNoticeResponseError)

export const getSendNoticeUrl = (noticeId: number,) => {




  return `/api/notices/${noticeId}/send`
}

/**
 * @summary Send Notice
 */
export const sendNotice = async (noticeId: number, options?: Parameters<typeof apiFetch>[1]): Promise<sendNoticeResponse> => {

  return apiFetch<sendNoticeResponse>(getSendNoticeUrl(noticeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendNoticeMutationKey = () => ['sendNotice'] as const;

export const getSendNoticeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotice>>, TError,SendNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendNotice>>, TError,SendNoticeMutationVariables, TContext> => {

const mutationKey = getSendNoticeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNotice>>, SendNoticeMutationVariables> = (props) => {
          const {noticeId} = props ?? {};

          return  sendNotice(noticeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendNoticeMutationResult = NonNullable<Awaited<ReturnType<typeof sendNotice>>>

    export type SendNoticeMutationError = HTTPValidationError
    export type SendNoticeMutationVariables = {noticeId: number}

    /**
 * @summary Send Notice
 */
export const useSendNotice = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotice>>, TError,SendNoticeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendNotice>>,
        TError,
        SendNoticeMutationVariables,
        TContext
      > => {
      return useMutation(getSendNoticeMutationOptions(options), queryClient);
    }
    export type recordNoticeDeliveryResponse200 = {
  data: NoticeOut
  status: 200
}

export type recordNoticeDeliveryResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type recordNoticeDeliveryResponseSuccess = (recordNoticeDeliveryResponse200) & {
  headers: Headers;
};
export type recordNoticeDeliveryResponseError = (recordNoticeDeliveryResponse422) & {
  headers: Headers;
};

export type recordNoticeDeliveryResponse = (recordNoticeDeliveryResponseSuccess | recordNoticeDeliveryResponseError)

export const getRecordNoticeDeliveryUrl = (noticeId: number,) => {




  return `/api/notices/${noticeId}/delivery`
}

/**
 * @summary Record Notice Delivery
 */
export const recordNoticeDelivery = async (noticeId: number,
    noticeDeliveryIn: NoticeDeliveryIn, options?: Parameters<typeof apiFetch>[1]): Promise<recordNoticeDeliveryResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<recordNoticeDeliveryResponse>(getRecordNoticeDeliveryUrl(noticeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noticeDeliveryIn)
  }
);}





export const getRecordNoticeDeliveryMutationKey = () => ['recordNoticeDelivery'] as const;

export const getRecordNoticeDeliveryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordNoticeDelivery>>, TError,RecordNoticeDeliveryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordNoticeDelivery>>, TError,RecordNoticeDeliveryMutationVariables, TContext> => {

const mutationKey = getRecordNoticeDeliveryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordNoticeDelivery>>, RecordNoticeDeliveryMutationVariables> = (props) => {
          const {noticeId,data} = props ?? {};

          return  recordNoticeDelivery(noticeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordNoticeDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof recordNoticeDelivery>>>
    export type RecordNoticeDeliveryMutationBody = NoticeDeliveryIn
    export type RecordNoticeDeliveryMutationError = HTTPValidationError
    export type RecordNoticeDeliveryMutationVariables = {noticeId: number;data: NoticeDeliveryIn}

    /**
 * @summary Record Notice Delivery
 */
export const useRecordNoticeDelivery = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordNoticeDelivery>>, TError,RecordNoticeDeliveryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordNoticeDelivery>>,
        TError,
        RecordNoticeDeliveryMutationVariables,
        TContext
      > => {
      return useMutation(getRecordNoticeDeliveryMutationOptions(options), queryClient);
    }
    export type getNoticePdfResponse200 = {
  data: Blob
  status: 200
}

export type getNoticePdfResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getNoticePdfResponseSuccess = (getNoticePdfResponse200) & {
  headers: Headers;
};
export type getNoticePdfResponseError = (getNoticePdfResponse422) & {
  headers: Headers;
};

export type getNoticePdfResponse = (getNoticePdfResponseSuccess | getNoticePdfResponseError)

export const getGetNoticePdfUrl = (noticeId: number,) => {




  return `/api/notices/${noticeId}/pdf`
}

/**
 * @summary Get Notice Pdf
 */
export const getNoticePdf = async (noticeId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getNoticePdfResponse> => {

  return apiFetch<getNoticePdfResponse>(getGetNoticePdfUrl(noticeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNoticePdfQueryKey = (noticeId: number,) => {
    return [
    `/api/notices/${noticeId}/pdf`
    ] as const;
    }


export const getGetNoticePdfQueryOptions = <TData = Awaited<ReturnType<typeof getNoticePdf>>, TError = HTTPValidationError>(noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticePdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNoticePdfQueryKey(noticeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoticePdf>>> = ({ signal }) => getNoticePdf(noticeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: noticeId !== null && noticeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNoticePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNoticePdfQueryResult = NonNullable<Awaited<ReturnType<typeof getNoticePdf>>>
export type GetNoticePdfQueryError = HTTPValidationError


export function useGetNoticePdf<TData = Awaited<ReturnType<typeof getNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNoticePdf>>,
          TError,
          Awaited<ReturnType<typeof getNoticePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNoticePdf<TData = Awaited<ReturnType<typeof getNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNoticePdf>>,
          TError,
          Awaited<ReturnType<typeof getNoticePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNoticePdf<TData = Awaited<ReturnType<typeof getNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticePdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Notice Pdf
 */

export function useGetNoticePdf<TData = Awaited<ReturnType<typeof getNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticePdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNoticePdfQueryOptions(noticeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getLateNoticeSettingsResponse200 = {
  data: LateNoticeSettingsOut
  status: 200
}

export type getLateNoticeSettingsResponseSuccess = (getLateNoticeSettingsResponse200) & {
  headers: Headers;
};
;

export type getLateNoticeSettingsResponse = (getLateNoticeSettingsResponseSuccess)

export const getGetLateNoticeSettingsUrl = () => {




  return `/api/orgs/current/late-notices`
}

/**
 * @summary Get Late Notice Settings
 */
export const getLateNoticeSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getLateNoticeSettingsResponse> => {

  return apiFetch<getLateNoticeSettingsResponse>(getGetLateNoticeSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLateNoticeSettingsQueryKey = () => {
    return [
    `/api/orgs/current/late-notices`
    ] as const;
    }


export const getGetLateNoticeSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getLateNoticeSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateNoticeSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLateNoticeSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLateNoticeSettings>>> = ({ signal }) => getLateNoticeSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLateNoticeSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLateNoticeSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getLateNoticeSettings>>>
export type GetLateNoticeSettingsQueryError = unknown


export function useGetLateNoticeSettings<TData = Awaited<ReturnType<typeof getLateNoticeSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateNoticeSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLateNoticeSettings>>,
          TError,
          Awaited<ReturnType<typeof getLateNoticeSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLateNoticeSettings<TData = Awaited<ReturnType<typeof getLateNoticeSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateNoticeSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLateNoticeSettings>>,
          TError,
          Awaited<ReturnType<typeof getLateNoticeSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLateNoticeSettings<TData = Awaited<ReturnType<typeof getLateNoticeSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateNoticeSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Late Notice Settings
 */

export function useGetLateNoticeSettings<TData = Awaited<ReturnType<typeof getLateNoticeSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLateNoticeSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLateNoticeSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setLateNoticeSettingsResponse200 = {
  data: LateNoticeSettingsOut
  status: 200
}

export type setLateNoticeSettingsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setLateNoticeSettingsResponseSuccess = (setLateNoticeSettingsResponse200) & {
  headers: Headers;
};
export type setLateNoticeSettingsResponseError = (setLateNoticeSettingsResponse422) & {
  headers: Headers;
};

export type setLateNoticeSettingsResponse = (setLateNoticeSettingsResponseSuccess | setLateNoticeSettingsResponseError)

export const getSetLateNoticeSettingsUrl = () => {




  return `/api/orgs/current/late-notices`
}

/**
 * @summary Set Late Notice Settings
 */
export const setLateNoticeSettings = async (lateNoticeSettingsIn: LateNoticeSettingsIn, options?: Parameters<typeof apiFetch>[1]): Promise<setLateNoticeSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setLateNoticeSettingsResponse>(getSetLateNoticeSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(lateNoticeSettingsIn)
  }
);}





export const getSetLateNoticeSettingsMutationKey = () => ['setLateNoticeSettings'] as const;

export const getSetLateNoticeSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLateNoticeSettings>>, TError,SetLateNoticeSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLateNoticeSettings>>, TError,SetLateNoticeSettingsMutationVariables, TContext> => {

const mutationKey = getSetLateNoticeSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLateNoticeSettings>>, SetLateNoticeSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setLateNoticeSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLateNoticeSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setLateNoticeSettings>>>
    export type SetLateNoticeSettingsMutationBody = LateNoticeSettingsIn
    export type SetLateNoticeSettingsMutationError = HTTPValidationError
    export type SetLateNoticeSettingsMutationVariables = {data: LateNoticeSettingsIn}

    /**
 * @summary Set Late Notice Settings
 */
export const useSetLateNoticeSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLateNoticeSettings>>, TError,SetLateNoticeSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLateNoticeSettings>>,
        TError,
        SetLateNoticeSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetLateNoticeSettingsMutationOptions(options), queryClient);
    }
    export type listRentChangesResponse200 = {
  data: RentChangesOut
  status: 200
}

export type listRentChangesResponseSuccess = (listRentChangesResponse200) & {
  headers: Headers;
};
;

export type listRentChangesResponse = (listRentChangesResponseSuccess)

export const getListRentChangesUrl = () => {




  return `/api/rent-changes`
}

/**
 * @summary List Rent Changes
 */
export const listRentChanges = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listRentChangesResponse> => {

  return apiFetch<listRentChangesResponse>(getListRentChangesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRentChangesQueryKey = () => {
    return [
    `/api/rent-changes`
    ] as const;
    }


export const getListRentChangesQueryOptions = <TData = Awaited<ReturnType<typeof listRentChanges>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRentChanges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRentChangesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRentChanges>>> = ({ signal }) => listRentChanges({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRentChanges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRentChangesQueryResult = NonNullable<Awaited<ReturnType<typeof listRentChanges>>>
export type ListRentChangesQueryError = unknown


export function useListRentChanges<TData = Awaited<ReturnType<typeof listRentChanges>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRentChanges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRentChanges>>,
          TError,
          Awaited<ReturnType<typeof listRentChanges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRentChanges<TData = Awaited<ReturnType<typeof listRentChanges>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRentChanges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRentChanges>>,
          TError,
          Awaited<ReturnType<typeof listRentChanges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRentChanges<TData = Awaited<ReturnType<typeof listRentChanges>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRentChanges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Rent Changes
 */

export function useListRentChanges<TData = Awaited<ReturnType<typeof listRentChanges>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRentChanges>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRentChangesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createRentChangeResponse201 = {
  data: RentChangeOut
  status: 201
}

export type createRentChangeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createRentChangeResponseSuccess = (createRentChangeResponse201) & {
  headers: Headers;
};
export type createRentChangeResponseError = (createRentChangeResponse422) & {
  headers: Headers;
};

export type createRentChangeResponse = (createRentChangeResponseSuccess | createRentChangeResponseError)

export const getCreateRentChangeUrl = (leaseId: number,) => {




  return `/api/leases/${leaseId}/rent-changes`
}

/**
 * @summary Create Rent Change
 */
export const createRentChange = async (leaseId: number,
    rentChangeIn: RentChangeIn, options?: Parameters<typeof apiFetch>[1]): Promise<createRentChangeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createRentChangeResponse>(getCreateRentChangeUrl(leaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rentChangeIn)
  }
);}





export const getCreateRentChangeMutationKey = () => ['createRentChange'] as const;

export const getCreateRentChangeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRentChange>>, TError,CreateRentChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRentChange>>, TError,CreateRentChangeMutationVariables, TContext> => {

const mutationKey = getCreateRentChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRentChange>>, CreateRentChangeMutationVariables> = (props) => {
          const {leaseId,data} = props ?? {};

          return  createRentChange(leaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRentChangeMutationResult = NonNullable<Awaited<ReturnType<typeof createRentChange>>>
    export type CreateRentChangeMutationBody = RentChangeIn
    export type CreateRentChangeMutationError = HTTPValidationError
    export type CreateRentChangeMutationVariables = {leaseId: number;data: RentChangeIn}

    /**
 * @summary Create Rent Change
 */
export const useCreateRentChange = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRentChange>>, TError,CreateRentChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRentChange>>,
        TError,
        CreateRentChangeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRentChangeMutationOptions(options), queryClient);
    }
    export type cancelRentChangeResponse200 = {
  data: RentChangeOut
  status: 200
}

export type cancelRentChangeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type cancelRentChangeResponseSuccess = (cancelRentChangeResponse200) & {
  headers: Headers;
};
export type cancelRentChangeResponseError = (cancelRentChangeResponse422) & {
  headers: Headers;
};

export type cancelRentChangeResponse = (cancelRentChangeResponseSuccess | cancelRentChangeResponseError)

export const getCancelRentChangeUrl = (changeId: number,) => {




  return `/api/rent-changes/${changeId}/cancel`
}

/**
 * @summary Cancel Rent Change
 */
export const cancelRentChange = async (changeId: number, options?: Parameters<typeof apiFetch>[1]): Promise<cancelRentChangeResponse> => {

  return apiFetch<cancelRentChangeResponse>(getCancelRentChangeUrl(changeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelRentChangeMutationKey = () => ['cancelRentChange'] as const;

export const getCancelRentChangeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRentChange>>, TError,CancelRentChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRentChange>>, TError,CancelRentChangeMutationVariables, TContext> => {

const mutationKey = getCancelRentChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRentChange>>, CancelRentChangeMutationVariables> = (props) => {
          const {changeId} = props ?? {};

          return  cancelRentChange(changeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRentChangeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRentChange>>>

    export type CancelRentChangeMutationError = HTTPValidationError
    export type CancelRentChangeMutationVariables = {changeId: number}

    /**
 * @summary Cancel Rent Change
 */
export const useCancelRentChange = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRentChange>>, TError,CancelRentChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRentChange>>,
        TError,
        CancelRentChangeMutationVariables,
        TContext
      > => {
      return useMutation(getCancelRentChangeMutationOptions(options), queryClient);
    }
    export type listRenewalsResponse200 = {
  data: PaginatedRenewalOut
  status: 200
}

export type listRenewalsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listRenewalsResponseSuccess = (listRenewalsResponse200) & {
  headers: Headers;
};
export type listRenewalsResponseError = (listRenewalsResponse422) & {
  headers: Headers;
};

export type listRenewalsResponse = (listRenewalsResponseSuccess | listRenewalsResponseError)

export const getListRenewalsUrl = (params?: ListRenewalsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/renewals?${stringifiedParams}` : `/api/renewals`
}

/**
 * @summary List Renewals
 */
export const listRenewals = async (params?: ListRenewalsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listRenewalsResponse> => {

  return apiFetch<listRenewalsResponse>(getListRenewalsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRenewalsQueryKey = (params?: ListRenewalsParams,) => {
    return [
    `/api/renewals`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRenewalsQueryOptions = <TData = Awaited<ReturnType<typeof listRenewals>>, TError = HTTPValidationError>(params?: ListRenewalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRenewalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRenewals>>> = ({ signal }) => listRenewals(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRenewalsQueryResult = NonNullable<Awaited<ReturnType<typeof listRenewals>>>
export type ListRenewalsQueryError = HTTPValidationError


export function useListRenewals<TData = Awaited<ReturnType<typeof listRenewals>>, TError = HTTPValidationError>(
 params: undefined |  ListRenewalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRenewals>>,
          TError,
          Awaited<ReturnType<typeof listRenewals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRenewals<TData = Awaited<ReturnType<typeof listRenewals>>, TError = HTTPValidationError>(
 params?: ListRenewalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRenewals>>,
          TError,
          Awaited<ReturnType<typeof listRenewals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRenewals<TData = Awaited<ReturnType<typeof listRenewals>>, TError = HTTPValidationError>(
 params?: ListRenewalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Renewals
 */

export function useListRenewals<TData = Awaited<ReturnType<typeof listRenewals>>, TError = HTTPValidationError>(
 params?: ListRenewalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRenewals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRenewalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createRenewalResponse201 = {
  data: RenewalOut
  status: 201
}

export type createRenewalResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createRenewalResponseSuccess = (createRenewalResponse201) & {
  headers: Headers;
};
export type createRenewalResponseError = (createRenewalResponse422) & {
  headers: Headers;
};

export type createRenewalResponse = (createRenewalResponseSuccess | createRenewalResponseError)

export const getCreateRenewalUrl = () => {




  return `/api/renewals`
}

/**
 * @summary Create Renewal
 */
export const createRenewal = async (renewalIn: RenewalIn, options?: Parameters<typeof apiFetch>[1]): Promise<createRenewalResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createRenewalResponse>(getCreateRenewalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renewalIn)
  }
);}





export const getCreateRenewalMutationKey = () => ['createRenewal'] as const;

export const getCreateRenewalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRenewal>>, TError,CreateRenewalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRenewal>>, TError,CreateRenewalMutationVariables, TContext> => {

const mutationKey = getCreateRenewalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRenewal>>, CreateRenewalMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRenewal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof createRenewal>>>
    export type CreateRenewalMutationBody = RenewalIn
    export type CreateRenewalMutationError = HTTPValidationError
    export type CreateRenewalMutationVariables = {data: RenewalIn}

    /**
 * @summary Create Renewal
 */
export const useCreateRenewal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRenewal>>, TError,CreateRenewalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRenewal>>,
        TError,
        CreateRenewalMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRenewalMutationOptions(options), queryClient);
    }
    export type withdrawRenewalResponse200 = {
  data: RenewalOut
  status: 200
}

export type withdrawRenewalResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type withdrawRenewalResponseSuccess = (withdrawRenewalResponse200) & {
  headers: Headers;
};
export type withdrawRenewalResponseError = (withdrawRenewalResponse422) & {
  headers: Headers;
};

export type withdrawRenewalResponse = (withdrawRenewalResponseSuccess | withdrawRenewalResponseError)

export const getWithdrawRenewalUrl = (offerId: number,) => {




  return `/api/renewals/${offerId}/withdraw`
}

/**
 * @summary Withdraw Renewal
 */
export const withdrawRenewal = async (offerId: number, options?: Parameters<typeof apiFetch>[1]): Promise<withdrawRenewalResponse> => {

  return apiFetch<withdrawRenewalResponse>(getWithdrawRenewalUrl(offerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getWithdrawRenewalMutationKey = () => ['withdrawRenewal'] as const;

export const getWithdrawRenewalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawRenewal>>, TError,WithdrawRenewalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof withdrawRenewal>>, TError,WithdrawRenewalMutationVariables, TContext> => {

const mutationKey = getWithdrawRenewalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawRenewal>>, WithdrawRenewalMutationVariables> = (props) => {
          const {offerId} = props ?? {};

          return  withdrawRenewal(offerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawRenewal>>>

    export type WithdrawRenewalMutationError = HTTPValidationError
    export type WithdrawRenewalMutationVariables = {offerId: number}

    /**
 * @summary Withdraw Renewal
 */
export const useWithdrawRenewal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawRenewal>>, TError,WithdrawRenewalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof withdrawRenewal>>,
        TError,
        WithdrawRenewalMutationVariables,
        TContext
      > => {
      return useMutation(getWithdrawRenewalMutationOptions(options), queryClient);
    }
